/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $MatchSmall = {
    properties: {
        id: {
            type: 'number',
            isRequired: true,
        },
        matchType: {
            type: 'MatchType',
            isRequired: true,
        },
        leagueTournamentId: {
            type: 'number',
            isRequired: true,
        },
        goal1: {
            type: 'number',
            isRequired: true,
        },
        goal2: {
            type: 'number',
            isRequired: true,
        },
        pauseDuration: {
            type: 'number',
            isRequired: true,
        },
        sectionAmount: {
            type: 'number',
            isRequired: true,
        },
        sectionDuration: {
            type: 'number',
            isRequired: true,
        },
        startTime: {
            type: 'string',
            isRequired: true,
            format: 'date-time',
        },
        firstHalfEndTime: {
            type: 'string',
            isRequired: true,
            format: 'date-time',
        },
        secondHalfStartTime: {
            type: 'string',
            isRequired: true,
            format: 'date-time',
        },
        endTime: {
            type: 'string',
            isRequired: true,
            format: 'date-time',
        },
        kickedOff: {
            type: 'any-of',
            contains: [{
                type: 'boolean',
            }, {
                type: 'null',
            }],
        },
        leagueTournamentName: {
            type: 'Translation',
            isRequired: true,
        },
        team1: {
            type: 'any-of',
            contains: [{
                type: 'TeamSmall',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
        team2: {
            type: 'any-of',
            contains: [{
                type: 'TeamSmall',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
        sports: {
            type: 'SportEnum',
            isRequired: true,
        },
        cancelled: {
            type: 'boolean',
            isRequired: true,
        },
        location: {
            type: 'any-of',
            contains: [{
                type: 'Location',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
        matchBoardLoaded: {
            type: 'any-of',
            contains: [{
                type: 'string',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
        matchDay: {
            type: 'number',
            isRequired: true,
        },
        matchTerminationType: {
            type: 'any-of',
            contains: [{
                type: 'MatchTerminationType',
            }, {
                type: 'null',
            }],
        },
        veo1: {
            type: 'any-of',
            contains: [{
                type: 'string',
            }, {
                type: 'null',
            }],
        },
        veo2: {
            type: 'any-of',
            contains: [{
                type: 'string',
            }, {
                type: 'null',
            }],
        },
    },
} as const;
